import { RemoveRound } from "@monta/icons";
import clsx from "clsx";
import { useAdditionalContext } from "../context/context";
import styles from "./styles.module.scss";

type Props = {
  moduleGroupFilters: { label: string; value: string }[];
};

const MobileAdditionalReportFilter = (props: Props) => {
  const { moduleGroupFilters } = props;

  const { setFilters, filters } = useAdditionalContext();

  return (
    <section className={styles["filter-mobile"]}>
      {moduleGroupFilters.map((item, key) => {
        const handleClick = () => {
          if (Number(item.value) === filters.selectedModuleGroup)
            setFilters({ ...filters, selectedModuleGroup: undefined });
          else
            setFilters({ ...filters, selectedModuleGroup: Number(item.value) });
        };

        return (
          <button
            key={key + "filter"}
            className={clsx(
              styles["filter-mobile__item"],
              Number(item.value) === filters.selectedModuleGroup &&
                styles["filter-mobile__item--active"],
            )}
            onClick={handleClick}
          >
            {item.label}
            {Number(item.value) === filters.selectedModuleGroup && (
              <RemoveRound onClick={handleClick} size={20} />
            )}
          </button>
        );
      })}
    </section>
  );
};

export default MobileAdditionalReportFilter;
